import React from "react";
export default class Step3 extends React.Component {
    render() {
        const { proteins, handleChange } = this.props;
        //@ts-ignore: This is passed through
        const nextStep = this.props.nextStep;
        return (React.createElement("div", { className: "card card-body protein-card" },
            React.createElement("p", null, "Please select the type of proteins you would like as part of your meals."),
            React.createElement("div", { className: "row" }, proteins.map((protein, idx) => (React.createElement("div", { className: "col-md", key: idx },
                React.createElement("div", { className: "form-check custom-check" },
                    React.createElement("input", { className: "form-check-input", type: "radio", name: "protein", value: protein.code, id: protein.code, onChange: (e) => handleChange(e, "protein", nextStep) }),
                    React.createElement("label", { className: "form-check-label", htmlFor: protein.code },
                        React.createElement("span", { className: "custom-check-text" }, protein.name)))))))));
    }
}
